import React, { useState } from 'react'
import { Button, Image } from 'react-bootstrap';
import './UserManageObject.css'
import ObjectList from './List/ObjectList';
import AccessRights from 'utils/AccessRights';
import { useSelector } from "react-redux";
import ObjectAdd from './add/ObjectAdd';

const UserManageObject = () => {
  const session = useSelector(state => state.session);
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <>
      <div className='wrapper-div'>
        <div className="d-flex justify-content-between align-items-center mb-3 px-4 pt-4">
          <h1 className="font-24 font-weight-s-bold page-heading">Objects</h1>
          {AccessRights(session.current_page_permissions, 'add') && (
            <button
              className='add-new-btn'
              variant='none'
              onClick={() => setShowAddModal(true)}
            >
              <Image src='/assets/images/add-icon.svg' className='me-2 add-user-icon' />
              Add New
            </button>
          )}
        </div>
        {/* component */}
        <ObjectList />
        <ObjectAdd
          show={showAddModal}
          onHide={() => setShowAddModal(false)}
        />
      </div>
    </>
  )
}

export default UserManageObject